<template lang="pug">
  SspLayout.batch-validation-page(area="core")
    .alert.alert-info
      i.glyphicon.glyphicon-info-sign
      |  Validate multiple codes at once
    form(role="form" @submit.prevent="")
      .form-group
        label(for="codes") Codes
        textarea#codes.form-control(v-model="codes")
      .text-right
        SspActionButton(:disabled="!codes" :spinning="validating" text="Validate" @onClick="batchAuthenticate")
    div(v-show="data.length > 0")
      small
        table#batch-validation-result-table.table.table-bordered(style="margin-top: 15px; margin-bottom: 0px;")
          thead
            tr
              th Code
              th Result
          tbody
            tr(v-for="d in data" :class="{ 'success': d.result.status === 'VALID', 'danger': d.result.status === 'INVALID', 'verified': d.result.status === 'VERIFIED'}")
              td.kzcode {{ d.code }}
              td
                span(v-if="d.result.status === 'VALID'") Valid
                span(v-else-if="d.result.status === 'VERIFIED'") Verified
                span(v-else) Invalid
        p Valid codes: {{ validCodesCount }} , invalid codes: {{ invalidCodesCount }}, verified codes: {{ verifiedCodesCount }}

</template>

<script>
import Core from '@/service/apis/Core'
import Util from '@/service/Util'

export default {
  data: () => ({
    validating: false,
    codes: null,
    data: []
  }),
  methods: {
    batchAuthenticate() {
      this.validating = true
      const cleanCodes = Util.sanitizeCodes(this.codes)
      const req = {
        codes: cleanCodes
      }

      const params = {
        fields: 'result'
      }

      return Core.batchValidate(req, params)
        .then((resp) => {
          this.data = resp.data
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.validating = false
        })
    }
  },
  computed: {
    validCodesCount() {
      if (this.data.length > 0) {
        const count = this.data.reduce((n, code) => n + (code.result.status === 'VALID'), 0)
        return count
      }
      return 0
    },
    invalidCodesCount() {
      if (this.data.length > 0) {
        const count = this.data.reduce((n, code) => n + (code.result.status === 'INVALID'), 0)
        return count
      }
      return 0
    },
    verifiedCodesCount() {
      if (this.data.length > 0) {
        const count = this.data.reduce((n, code) => n + (code.result.status === 'VERIFIED'), 0)
        return count
      }
      return 0
    }
  }
}
</script>

<style lang="scss">
.batch-validation-page {
  textarea {
    max-width: 100%;
    min-height: 10vh;
  }

  .verified {
    background-color: rgba(255, 255, 110, 0.3) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/validation/BatchValidator.vue